import { render, staticRenderFns } from "./Tanya.vue?vue&type=template&id=0bda819c&scoped=true"
import script from "./Tanya.vue?vue&type=script&lang=js"
export * from "./Tanya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bda819c",
  null
  
)

export default component.exports